<template>
  <div class="enter">
    <p class="p"><el-link href="/" :underline="false">首页</el-link> / <span @click="detailHref">心理知识</span> / {{titles}}
    </p>
    <div class="mentBody">
      <h3 v-if="titles == '复原力'">复原力
        <b>在无常变化中提升自我复原力</b>
      </h3>
      <h3 v-if="titles == '关于抑郁症的科普'">关于抑郁症的科普
        <b>重性抑郁障碍的知识分享复原力</b>
      </h3>
      <h3 v-if="titles == '失眠:深入理解及其缓解之道'">失眠:深入理解及其缓解之道<br /><br /><br /></h3>
      <h3 v-if="titles == 'PTSD&ASD的基础知识、治疗以及创伤后成长'">PTSD&ASD的基础知识、治疗以及创伤后成长<br /><br /><br /></h3>
      <h3 v-if="titles == '心中的拉锯战:理解认知解离的根源'">心中的拉锯战:
        <b>理解认知解离的根源</b>
      </h3>
      <div class="mentalBox" v-if="titles == '复原力'">
        <b>什么是复原力？</b>
        <p>
          ”复原力"（Resilience）是一个心理学术语，用于描述个体在面对压力、困难、挫折或其他形式的逆境时，能够迅速恢复到原先的正常状态（或者接近正常状态）的能力。这一概念在心理健康、领导力培训、教育以及其他多个领域都有应用。
        </p>
        <p>具有高复原力的人通常能更好地处理压力和挑战，他们具备适应性、灵活性，并能从困境中学习和成长。在面对失败或困难时，他们不易气馁，而是能积极找出解决问题的办法。</p>
        <p>复原力并不是一种天生就有的特质，而是可以通过心理训练、社会支持、积极心态等方式逐渐培养和提升的。</p>
        <b>高复原力的人的特点与案例</b>
        <p>复原力高的人，具有以下特点：</p>
        <p>1. 乐观积极。他们对未来抱有希望，相信自己能够克服困难。</p>
        <p>2. 自尊自信。他们相信自己的能力，能够应对挑战。</p>
        <p>3. 适应力强。他们能够灵活应对变化，不容易被打倒。</p>
        <p>4. 社交支持强。他们拥有良好的人际关系，能够从他人身上获得支持和力量。</p>
        <p>5. 自我效能高。他们相信自己能够取得成功，并为之努力奋斗。</p><br />
        <p>海伦 · 凯勒</p>
        <p>海伦 · 凯勒是一位著名的盲聋人作家和教育家。她在19个月大时就双目失明，又在六岁时失去了听力。这对她来说是一个巨大的挑战，但她并没有放弃自己的人生。</p>
        <p>在老师安妮 · 沙利文的帮助下，海伦 · 凯勒学会了说话和阅读。她还考入了哈佛大学，成为第一位盲聋人大学生。</p>
        <p>海伦 · 凯勒的人生经历表明，她具有很强的复原力。她能够在逆境中保持乐观 积极的心态，不断学习和成长。她还拥有良好的人际关系，在安妮 · 沙利文等人的帮助下，她克服了重重困难，取得了非凡的成就。</p>
        <p>以下是海伦 · 凯勒复原力的一些具体表现：</p>
        <p>1. 乐观积极的心态。海伦 · 凯勒在失明和失聪后，并没有陷入悲观绝望，而是选择了积极面对生活。她说： “我发现，如果我能用眼睛来思考，我就能用心灵来看到。 ”</p>
        <p>2. 坚强的意志。海伦 · 凯勒克服了重重困难，取得了非凡的成就。她说： “我相信，只要人愿意努力，就可以克服任何困难。 ”</p>
        <p>3. 良好的人际关系。海伦 · 凯勒在老师安妮 · 沙利文的帮助下，学会了说话和阅读。她还拥有许多朋友，在他们的支持和鼓励下，她能够坚强地面对困难。</p>
        <p>海伦 · 凯勒的故事告诉我们，复原力是一种强大的力量，它可以帮助我们在逆境中重新站起来，并取得成功。</p>
        <br />
        <p>李娜</p>
        <p>李娜是一位著名的网球运动员，曾获得过20个大满贯冠军。她在职业生涯中经历了许多挫折，包括伤病、失败等，但她都能够坚强地面对，并不断取得突破。</p>
        <p>李娜从小就展现出网球天赋。她在16岁时获得了法国网球公开赛的冠军，成为 最年轻的大满贯冠军得主。然而，在接下来的几年里，李娜遭遇了严重的伤病，一度退出赛场。</p>
        <p>在休养期间，李娜并没有放弃网球，而是继续训练。她还参加了各种慈善活动，帮助那些同样遭受伤病困扰的人。</p>
        <p>2011年，李娜重返赛场，并在澳大利亚网球公开赛上获得了冠军。这场胜利不仅是李娜个人的胜利，也是对她坚强意志的证明。</p>
        <p> 李娜的职业生涯表明，她具有很强的复原力。她能够在逆境中保持乐观积极的心态，不断努力奋斗，并取得了非凡的成就。</p>
        <p>以下是李娜复原力的一些具体表现：</p>
        <p>1. 乐观积极的心态。李娜在经历了伤病和失败后，并没有放弃网球，而是选择了积极面对。她说： “我相信，只要我努力，就一定能够克服困难。 ”</p>
        <p>2. 坚强的意志。李娜在重返赛场后，取得了一系列突破。她说：“我相信，只要我相信自己，就没有什么不可能。 ”</p>
        <p>3. 自我效能感。李娜在职业生涯中取得了许多成就，这增强了她对自己的信心。她说： “我相信，我能够做到任何事情。 ”</p>
        <p>李娜的故事告诉我们，复原力是一种可以培养和提升的能力。我们在面对挫折和困难时，要保持乐观积极的心态，不断努力奋斗，并相信自己能够克服困难。</p>

        <b>提高复原力：哈佛的观点与实用策略</b>
        <p>复原力是人们在面对逆境、压力和各种生活的挑战时，恢复和适应的能力。它 是帮助我们克服困难、适应变化和继续前进的关键因素。哈佛大学的研究为我们提供了深入的洞察和策略来提高这一关键技能。</p>
        <br />
        <p>理解复原力的多维性</p>
        <p>根据哈佛的研究，复原力并不是一个单一的、固定的品质，而是多个相互关联 的心理和行为因素的组合。这包括认知灵活性、情感调节、问题解决能力和社交支持。</p>
        <p>1. 认知再评估：</p>
        <p>哈佛的心理学家发现，我们如何看待挑战和压力对我们的反应有很大的影响。 通过重新评估和挑战我们对压力的认知，我们可以更加积极地看待困境，并找到应对它们的方式。例如，将挑战视为成长的机会，而不是威胁。</p>
        <p>实用案例: 假设你被突然解雇了。而不是看作一次失败或耻辱，将其视为一个探索新职业道路或学习新技能的机会。这种思维转换能减轻你的心理压力，并可能帮助你更快地找到新的工作。</p>
        <p>2. 建立关系：</p>
        <p>哈佛的研究表明，与他人建立深厚的人际关系是提高复原力的关键。支持、理解和情感的联系可以为我们提供必要的力量来克服困难。</p>
        <p>实用案例: 假设你正在经历一段困难的时期，如失恋或亲人去世。此时，与朋友和家人建立紧密的联系，甚至参与社群活动，会为你提供情感支持，并帮助你更快地恢复。</p>
        <p>3. 正念冥想：</p>
        <p>哈佛大学的神经科学家发现，正念冥想不仅可以减轻压力，还可以帮助我们更好地应对挑战和逆境。通过培养我们的注意力和意识，我们可以更好地理解和处理我们的情感和反应。</p>
        <p>实用案例: 当你感到压力增大时，尝试进行5到10分钟的正念冥想。通过聚焦你的呼吸或身体的感觉，你可以将注意力从压力源转移出来，从而减轻压力。</p>
        <p>4. 接受并适应变化：</p>
        <p>哈佛商学院的研究发现，适应力和灵活性是当今商业环境中最宝贵的技能。同 样，这些技能也对我们个人的复原力至关重要。学会适应变化和不确定性，是克服困难的关键。</p>
        <p>实用案例: 假如你是一个企业经理，突然被告知需要削减预算。而不是产生恐慌或抵抗，你可以迅速适应这一变化，寻找替代方案来达成目标。</p>
        <p>5. 终身学习：</p>
        <p>哈佛的研究也表明，持续的学习和成长对提高复原力至关重要。不断地学习新的技能和知识，不仅可以帮助我们应对挑战，还可以为我们提供新的机会和视角。</p>
        <p>实用案例：你可能在工作中遇到了一个你不懂的新技术问题。而不是感到沮喪，你可以把这看作是学习和成长的机会，通过培训或自学来解决这个问题。</p>

        <b>评估自己的复原力</b>
        <p>评估复原力可以通过多种方法进行，包括自我评估问卷、专家评估和行为观察。以下是一些评估自己复原力的方法：</p>
        <br />
        <p>自我评估问卷：</p>
        <p>1. 您是否能够在面对逆境时保持冷静和理性？</p>
        <p>2. 面对压力时，您是否能迅速找到有效的应对策略？</p>
        <p>3. 在经历失败或失望后，您能否迅速振作起来并采取行动？</p>
        <p>4. 您是否经常主动寻求支持或帮助，而不是独自承受困境？</p>
        <p>5. 您是否经常练习正念或其他减压技巧来保持冷静？</p>
        <p>观察日常反应：观察自己在面对困难和压力时的反应。例如，当面对失败时，您是否容易放弃或您会尝试寻找其他方法并继续前进？</p>
        <p>寻求他人的反绩：询问家人、朋友或同事他们如何看待您的复原力。他们可能会提供您未曾注意到的宝贵观点。</p>
        <p>设置挑战：故意为自己设置一些挑战或困难，观察自己在这些情境中的反应。这可以帮助您了解自己在压力下的应对策略和反应模式。</p>
        <p>专业评估：有些心理学家和治疗师可能提供专门的复原力评估工具或服务。这些工具可以帮助您更深入地了解自己的强项和需要改进的地方。</p>
        <p>日常记录：保持日记，记录每天的事件和自己的反应。这可以帮助您观察到自己在面对压力和挑战时的反应模式。</p>
        <p>综合以上方法，可以更准确地评估自己的复原力，从而找到需要提高的领域并采取相应的措施。</p>

        <b>结语</b>
        <p>
          总结来说，提高个人的复原力不仅仅是关于如何从逆境中恢复，更是关于如何通过每一次的挑战变得更加坚强，塑造我们成为更有能力和韧性的个体。生命的旅程充满了高潮和低谷，但通过增强复原力，我们为自己装备了不仅仅是忍受，而是在挑战中蓬勃发展的能力。正如著名的美国作家Elizabeth
          Edwards曾经说过：“复原力是接受你的新现实，即使它比你之前拥有的要差。你可以对抗它，你可以什么都不做，只是尖叫你失去了什么，或者你可以接受它，试图组合一些好的东西。
          ”让我们不断努力提高我们的复原力，并在每次遇到的情况中创造那个"好"。</p>
      </div>
      <div class="mentalBox" v-if="titles == '关于抑郁症的科普'">
        <b>定义</b>
        <p>重性抑郁障碍（Major Depressive Disorder， MDD）是一种精神疾病，表现为持续的悲伤、失望和兴趣缺失，并伴有其他症状，如失眠、食欲改变、注意力不 集中和疲劳。
          MDD是一种严重的疾病，会影响一个人的思维、情绪和行为。</p>

        <b>成因</b>
        <p>MDD 的成因尚不完全清楚，但可能与多种因素有关，包括遗传、神经化学、 环境和生活事件。</p>
        <p>遗传因素：MDD 家族中患病风险较高，表明遗传因素可能是一个重要因素。</p>
        <p>神经化学因素：MDD 患者大脑中的神经递质，如血清素、多巴胺和去甲肾上 腺素水平通常较低。</p>
        <p>环境因素：童年创伤、压力和药物滥用等环境因素也可能增加患 MDD 的风 险。</p>

        <b>如何预防</b>
        <p>目前尚无有效的预防 MDD 的方法，但以下措施可能有所帮助：</p>
        <p>1. 保持健康的生活方式：包括健康的饮食、适量的运动和充足的睡眠。</p>
        <p>2. 学会应对压力：通过健康的方式应对压力，如运动、冥想或瑜伽。</p>
        <p>3. 寻求支持：与朋友、家人或心理健康专业人士保持联系。</p>

        <b>DSM5诊断方法和案例</b>
        <p>根据《精神疾病诊断与统计手册第五版》（ DSM-5）， MDD 的诊断标准包括 以下几点：</p>
        <p>1. 至少两周持续存在的抑郁情绪，如悲伤、失望和绝望。</p>
        <p>2. 兴趣或愉悦感的显著减少或丧失。</p>
        <p>3. 体重增加或减少，与饮食习惯无关，至少 5% 的体重变化。</p>
        <p>4. 睡眠障碍，如失眠或嗜睡。</p>
        <p>5. 精神运动迟缓或激越。</p>
        <p>6. 疲劳或精力减退。</p>
        <p>7. 自尊心降低。</p>
        <p>8. 注意力不集中或决策困难。</p>
        <p>9. 反复出现死亡或自杀的想法或行为。</p>
        <p>以上仅诊断的部分内容，并不能作为完全的诊断依据。详情和更加详细的诊断 信息，请自行查阅《精神疾病诊断与统计手册第五版》（ DSM-5）。</p>
        <p>以下是一个 MDD 的诊断案例：</p>
        <p>小明是一名 25 岁的男性，他最近一直感到悲伤、失望和绝望。他对自己失去 了兴趣，也不想做任何事情。他还失去了食欲，体重下降了 10 公斤。他经常失眠，白天感到疲劳。他感到自己很无用，并经常有自杀的想法。</p>
        <p>小明去看了医生，医生诊断他患有重性抑郁障碍。医生给他开了抗抑郁药物，并建议他接受心理治疗。小明服用了抗抑郁药物后，他的症状有所改善。他开始感到更快乐和更有动力。他还开始接受心理治疗，这有助于他了解自己的感受并应对抑郁。
        </p>

        <b>治疗方式和案例</b>
        <p>MDD 的治疗通常包括药物和心理治疗。</p>
        <p>药物治疗：药物治疗是 MDD 的常用治疗方法，可以帮助改善症状。常用的抗 抑郁药物包括选择性血清素再摄取抑制剂（ SSRIs）、 5-羟色胺和去甲肾上腺素再 摄取抑制剂（ SNRIs）和三环抗抑郁药（TCAs）。
        </p>
        <p>心理治疗：心理治疗也可以帮助改善 MDD 的症状。常用的心理治疗方法包括 认知行为治疗（ CBT）、人际关系疗法（ IPT）和家庭疗法。</p>

        <b>自己如何从抑郁中走出来</b>
        <p>走出抑郁不是一蹴而就的过程，而是需要时间、努力和持续的支持。下面是一 些方法，帮助个人从抑郁中走出来：</p>
        <p>1. 专业治疗:</p>
        <p>药物治疗：抗抑郁药可以帮助调整大脑中的化学物质，缓解抑郁症状。</p>
        <p>心理治疗：例如认知行为疗法，它可以帮助病人识别并改变消极的思维和行 为模式。</p>
        <p>2. 日常生活中的自助策略：</p>
        <p>保持日常活动：即使感觉没有动力，也要努力维持日常的活动和工作。</p>
        <p>锻炼：定期锻炼可以释放内啡肽，这是一种能够提升情绪的化学物质。</p>
        <p>饮食调整：均衡的饮食可以有助于身体健康，提高情绪。</p>
        <p>规律作息：确保每天都有足够的睡眠，避免过度劳累。</p>
        <p>3. 社交支持：</p>
        <p>寻求社交支持：和家人、朋友、同事或专家分享自己的感受。</p>
        <p>参与团体活动：如参加抑郁症患者的支持团体。</p>
        <p>4. 学习应对技巧：</p>
        <p>放松技巧：如冥想、深呼吸和渐进性肌肉放松等。</p>
        <p>避免酒精和药物滥用：这些物质可能会加重抑郁症状。</p>
        <p>5. 避免消极刺激：</p>
        <p>如减少观看过于消极的新闻或社交媒体，避免与负能量的人过多交往。</p>
        <p>6. 培养乐观思维：</p>
        <p>记录感恩的事情，重视积极的经历。</p>
        <p>对抗消极思维，学习正确认知和评价自己。</p>
        <p>7. 设定小目标：</p>
        <p>制定简单实现的日常目标，每次达成都能带来成就感。</p>
        <p>8. 避免重大决策：</p>
        <p>当处于抑郁状态时，尽量避免做重大的生活决策。</p>
        <p>9. 限制应激：</p>
        <p>学会说“不” ，避免过度承担任务或责任。</p>
        <p>10. 教育自己：</p>
        <p>了解抑郁症，知道它是什么，如何形成，这可以帮助更好地应对。</p>
        <p>每个人的情况都是独特的，因此可能需要尝试不同的策略，才能找到最适合自 己的方法。如果你或你认识的人正在经历抑郁症，务必寻求专业帮助。</p>
        <br />
        <br />
        <p>
          生活中的低谷和阴影是无法避免的，但请记住，您并不孤单。有时，我们都会感受到沉重的情感压力和孤独。当您觉得自己被困在黑暗中时，请勇敢地寻求帮助和支持。每一个经历都是成长的一部分，而暴风雨之后，天空会更加明亮。您的感受是真实的，也值得被理解和关心。请珍惜自己，给自己时间和空间去愈合。您值
          得获得幸福和爱。</p>
      </div>
      <div class="mentalBox" v-if="titles == '失眠:深入理解及其缓解之道'">
        <b>什么是失眠？</b>
        <p>失眠，一个大家耳熟能详的词汇，但是你真正了解它吗？失眠，或称为睡眠障 碍，是指在合适的睡眠环境和条件下，个体出现入睡困难、维持睡眠的能力减退或
          早醒等导致睡眠时间或睡眠质量不足的情况。失眠可能是短期的，也可能是长期的，而且可能会影响到一个人在白天的功能，包括情感、认知和身体健康。</p>
        <p>失眠的常见症状包括：</p>
        <p>1. 入睡困难</p>
        <p>2. 睡眠障碍发生时，个体有足够的机会睡觉。</p>
        <p>3. 夜间醒来后难以再次入睡</p>
        <p>4. 早上过早醒来</p>
        <p>5. 白天感到疲劳或困倦</p>
        <p>6. 睡眠障碍导致了重要的功能受损，这可能体现在白天的疲劳、注意力不集中、社交功能受损、工作或学术功能受损、情绪障碍等方面。</p>
        <p>7. 对日常活动的兴趣或能力减退</p>

        <b>失眠的原因</b>
        <p>失眠的原因多种多样，可能涉及生活方式、环境、身体健康、精神健康和某些 物质或药物。长期失眠可能会增加患某些疾病的风险，如心血管疾病、糖尿病和抑郁症。</p>

        <p>a) 个人原因</p>
        <p>1. 压力 : 工作、学业或家庭的压力都可能导致人们难以入睡。</p>
        <p>2. 情绪问题: 抑郁症、焦虑症或其他情绪障碍都可能引发失眠。</p>
        <p>3. 生物钟紊乱 : 跨时区旅行、经常更改作息时间等都可能干扰我们的生物钟。</p>
        <p>4. 药物与饮食 : 某些药物和咖啡因等刺激性物质都可能影响睡眠。</p>
        <p>b) 环境原因</p>
        <p>1. 噪音 : 嘈杂的环境可能使人难以入睡或经常醒来。</p>
        <p>2. 光线: 过亮或不够暗的环境都可能干扰我们的睡眠。</p>
        <p>3. 温度: 过热或过冷的环境都可能影响睡眠。</p>
        <p>c) 遗传因素</p>
        <p>1. 研究表明，失眠可能有遗传因素，即有失眠家族史的人更容易受到影响。</p>
        <p>d) 神经科学原因</p>
        <p>1. 神经递质: 如血清素和多巴胺与睡眠-觉醒调节有关。失调可能导致睡眠问题。</p>
        <p>2. 褪黑素: 褪黑素是由松果体分泌的激素，与昼夜节律调节有关。其分泌受光线影响，与失眠的发生和持续有关。</p>
        <p>3. 脑结构: 脑的某些区域与睡眠调节有关，损伤或功能异常可能影响睡眠。</p>

        <b>如何减少失眠？</b>
        <p>1. 保持规律的睡眠时间：每天同一时间上床睡觉，同一时间起床。这样可以帮助建立起生物钟，促进睡眠。</p>
        <p>2. 睡前不要喝咖啡或茶，避免摄入酒精：咖啡因和茶碱具有兴奋作用，会干扰睡眠。酒精虽然可以帮助入睡，但会导致睡眠浅，影响睡眠质量。</p>
        <p>3. 睡前不要吃太饱或太饿：吃太饱会加重胃肠负担，影响睡眠。吃太饿会导致身体产生饥饿感，影响入睡。</p>
        <p>4. 睡前做放松的活动：睡前做一些放松的活动，如听音乐、泡澡、读书等，可以帮助放松身心，促进睡眠。</p>
        <p>5. 保持卧室安静、黑暗、凉爽：卧室应该保持安静、黑暗、凉爽，这样可以 帮助创造一个良好的睡眠环境。减少噪音和光线，考虑使用暖色调的灯泡来替换高蓝光灯泡，尤其是在晚上。</p>
        <p>6. 在晚上避免使用发出大量蓝光的设备，如智能手机、电视和电脑，或使用 蓝光过滤镜和应用程序来减少蓝光的影响。蓝光可能抑制褪黑素的分泌，从而影响睡眠。</p>
        <p>7. 避免在卧室工作或娱乐：卧室应该是专门用于睡觉的地方，避免在卧室工作或娱乐，这样可以避免在卧室产生兴奋感。</p>
        <p>8. 锻炼身体：适当的锻炼可以促进睡眠，但不要在睡前锻炼。</p>
        <p>9. 如果失眠严重，应及时就医：如果失眠严重，影响了日常生活，应及时就医，寻求专业的治疗。</p>
        <p>10.体育运动: 适量的体育运动，特别是在白天进行，可以帮助调节生物钟和增强睡眠的质量。然而，建议避免在睡前近几小时进行剧烈的运动。</p>
        <p>11.睡眠日记：可以帮助您了解自己的睡眠情况，找出导致失眠的原因。</p>
        <p>12.心理咨询：可以帮助您改变不良的睡眠习惯，改善睡眠态度。</p>

        <b>结语</b>
        <p>失眠，这个在现代社会中常见的困扰，无疑是许多人努力解决的难题。我们的 身体和心灵都需要充足、高质量的睡眠来恢复和再生。而在快节奏的生活和技术的 持续冲击下，找到高效的睡眠方法显得尤为重要。从理解失眠的复杂原因，到采取
          实际的步骤来改善睡眠，每一个措施都是对我们整体健康的积极投资。当我们深入 探索和尝试各种策略，如调整作息、改善睡眠环境、参与体育运动，甚至是简单地 更换一盏灯泡，我们都在为自己创造一个更健康、更有活力的未来。最后，睡眠的
          质量并不仅仅是数量的问题，它是一种生活态度、一种关心自己的方式。对于那些 长时间受到失眠困扰的人，不要沮丧，积极寻求帮助和解决方案。一个安稳的夜晚可能就在下一个转角。</p>
      </div>
      <div class="mentalBox" v-if="titles == 'PTSD&ASD的基础知识、治疗以及创伤后成长'">
        <p style="text-indent:32px;">在我们所生活的世界中，个体可能会遭遇各种形式的创伤或极端应激事件，从自然灾害到人为的暴力行为，从突如其来的失落到战争与冲突（Smith,
          2019）。这些事件所留下的影响，尤其在心理和情感层面，可能会持续很长时间，甚至是终身（Jones & Williams,
          2020）。在众多的心理健康障碍中，创伤后应激障碍（PTSD）和急性应激障碍（ASD）是两种与此类创伤事件直接相关的反应。它们
          都在某种程度上代表了人们在经历了极端应激事件后的心理和情感反应。本报告将为您深入剖析这两种障碍的概念、诊断标准、实际案例以及最新的治疗方法。
        </p>
        <b>什么是PTSD？
        </b>
        <p>创伤后应激障碍PTSD（ Post-Traumatic Stress Disorder）是由于经历了某种形 式的创伤性事件，如战争、严重的身体伤害、性侵、恐怖袭击等，而出现的一系列持续的心理反应。 DSM-5
          ，即《精神障碍诊断与统计手册第五版》，为我们提供了 明确的PTSD诊断标准（American Psychiatric Association, 2013）。首先，必须有
          直接或间接的创伤暴露。这可以是亲自经历，目击，或者是在工作中频繁接触相关 信息，如法医人员或急救人员。其次，患者可能会持续、反复地体验与创伤有关的 闪回、噩梦或侵入性思绪。此外，他们也会努力回避与创伤相关的任何事物，包括
          避免与此相关的地方、人们或活动，并可能对外部世界表现出情感的麻木。在消极 的情绪和思绪方面，患者可能会经常感到愧疚、自责或与他人疏离。最后，明显的
          增强反应性可能会表现为对突然的声音或动作过度反应、愤怒、睡眠问题或过度的警戒性（ DSM-5 2016）。具体详细的诊断标准请参考 DSM-5。
        </p>
        <p>关于PTSD ，我们可以考虑以下两个典型案例： 1) John，一个伊拉克战争的退
          伍军人，自从从战场回来后，经常经历战斗的闪回，尤其是在听到爆炸声或枪声时。夜晚，他经常因为恐怖的梦魇而惊醒，并发现自己汗流浃背。在日常生活中， 他避免与人交往，尤其是与可能讨论战争的人。2)
          Mary，一个性侵幸存者，尽管 事情已经过去了五年，但她仍然无法走进一个黑暗的房间或与陌生男性独处。每当她尝试与人发展亲密关系时，她都会回忆起那个恐怖的夜晚。
        </p>
        <b>什么是ASD？
        </b>
        <p>急性应激障碍ASD（Acute Stress Disorder）与PTSD非常相似，但其症状出 现的时间较短，通常在创伤事件后的3天到4周内（ DSM-5 2016）。具体详细的诊断标准请参考DSM-5。
        </p>
        <p>关于ASD ，以下是两个例子： 1) Alice，一个地震幸存者，在地震发生后的第 二天，她就开始经历强烈的解离感，经常觉得自己是在梦境中。她还经常回避与家 人和朋友的亲密接触，因为她害怕再次失去他们。2)
          Bob，一个银行劫持事件的目 击者，虽然他没有受到身体伤害，但在事件发生后的两周内，他避免走进任何银行，并在夜晚常常梦见劫持情境。
        </p>
        <b>心理疗法
        </b>
        <p>治疗创伤后应激障碍的目标是帮助受害者重新掌控生活。虽然心理疗法是首选治疗手段，药物治疗也是一个有效选择。对于儿童和成人的创伤后应激障碍（PTSD），有多种心理疗法或称谈话疗法可供选择。常见的方法有：
        </p>
        <p>1. 认知疗法：这种方法旨在帮助患者识别和改变导致问题的思维模式，例如 对自己的消极看法或对创伤再次发生的过度担忧。对于 PTSD ，它通常与暴露疗法结合使用。
        </p>
        <p>2. 暴露疗法：这种疗法助力于在一个安全的环境中面对和处理恐怖的记忆或 情境，如此可以学习如何有效应对。对于 PTSD 的情境回忆和噩梦，它特别有效。有时，可能会利用虚拟现实技术帮助面对和处理创伤经历。
        </p>
        <p>3. 眼动脱敏再处理疗法 (EMDR)： EMDR 结合了暴露疗法和系列化的眼球指导运动，旨在处理创伤记忆并改变对其的反应。
        </p>
        <p>其中最推荐的干预措施是认知行为疗法（ CBT）（APA 2020），建议4-16周，每周1-2次（APA 2020）。此外，治疗师还会教授如何培养应对压力的技能，
          让患者在日常生活中更好地应对各种压力。结合各种治疗方法可以帮助克服创伤后 的长期恐惧。患者可以与心理健康专家探讨，选择最适合其需求的治疗方法。无论
          选择个体疗法、团体疗法或两者结合，团体疗法都为患者提供了一个与经历相似的人交往的机会。
        </p>
        <p>ASD的治疗主要目标是减轻症状并防止其发展为PTSD ，通常采用认知行为疗法。</p>

        <b>尚不构成诊断为PTSD和ASD的心理亚健康</b>
        <p>值得注意的是，心理创伤后的影响可能是多方面的。即使个体没有发展为可诊 断的障碍，如创伤后应激障碍（ PTSD）或急性应激障碍（ASD），他们仍然可能
          经历长期的影响，这些影响可以影响他们生活的各个方面。后果可以从轻微的干扰到日常功能的显著干扰。
        </p>
        <p>1. 情感反应：这可能包括持续的悲伤、愤怒、内疚或情感麻木的感觉。个体可能会发现自己更容易烦躁，或者他们可能经常感到不堪重负或无望。
        </p>
        <p>2. 认知变化：有些人可能在集中注意力或做决策上有困难。他们还可能对自己、他人或整个世界产生负面的信念，例如 “我是无能的”或“世界是一个危险的地方 ”。
        </p>
        <p>3. 行为变化：这可以表现为回避行为，个体可能会避开提醒他们创伤事件的 地方、人或活动。他们还可能发展新的习惯或例行公事，以最小化感知的风险。
        </p>
        <p>4. 生理症状：创伤事件可能会导致睡眠障碍，如失眠或噩梦。有些个体可能还会经历疲劳、容易被惊吓或总有一种处于紧张状态的感觉。
        </p>
        <p>5. 人际关系困难：创伤可能会影响一个人信任他人的能力，导致在形成新的关系或维持现有关系上出现挑战。它还可以影响亲密关系和家庭动态。
        </p>
        <p>6. 物质使用：为了应对情感上的痛苦，有些人可能转向酒精、毒品或其他物质，这可能导致上瘾或依赖。
        </p>
        <p>虽然这些影响可能不一定符合PTSD或ASD的标准，但它们仍然是显著的，并且需要引起关注。识别这些症状并寻求适当的支持，无论是通过治疗、咨询还是其他资源，都是治愈和康复的关键。</p>

        <b>创伤后成长</b>
        <p>经历创伤后应激障碍（ PTSD）和急性应激障碍（ASD）常常被视为带来负面影响的心理障碍。然而，这并不意味着创伤经历只会导致消极后果。事实上，在一
          些情况下，经历创伤后，个体可能会经历所谓的“Post-Traumatic
          Growth”（PTG）或“创伤后成长 ”。
        </p>
        <b>什么是Post-Traumatic Growth (PTG)?</b>
        <p>创伤后成长（ PTG）是一种心理学概念，描述了人们在经历了重大创伤或压力
          事件后可能出现的正面心理变化。这些变化往往表现为个体在心理韧性、生活意义、人际关系和个人力量等方面的增长。与仅仅“恢复”到创伤前的状态不同，创伤后成长涉及到一种更深层次的变化，个体不仅能更好地应对当前的挑战，还能更好
          地应对未来可能面临的其他挑战。根据Wu等人的系统分析，近50%的创伤幸存者在经历创伤事件后经历了中度到高度的创伤后成长（Wu 2019）。
        </p>
        <b>案例：</b>
        <p>
          一位在地震中失去家园的女士。在经历了最初的震惊、悲伤和恐惧后，她决定参与重建社区的工作，并在过程中发现了自己的领导才能。这场灾难也让她重新评估了自己的生活目标，她决定更多地投身公益事业。尽管她绝不会忘记那次地震带来的伤痛，但她确实从中找到了新的生命方向和意义。
        </p>
        <b>如何实现PTG？</b>
        <p>创伤后成长（ Post-Traumatic Growth，简称PTG）确实为我们提供了一个更为 全面和积极的视角，来看待如何从痛苦的经历中找到成长和发展的可能性。然而，
          实现这一点并非易事，也并非所有人都会经历这种积极的转变。对于希望通过创伤实现个人成长的人来说，以下几点建议或许能提供一些启示。
        </p>
        <p>1. 增强心理韧性：心理韧性是应对压力和逆境的能力，它可以通过多种方式 来培养。例如，学习调解技巧、锻炼身体和寻求社会支持都有助于提高心理韧性。
        </p>
        <p>2. 建立强有力的支持网络：有研究表明，拥有强有力的社会支持网络可以促 进创伤后成长。不仅亲友的支持重要，有时候专业的心理治疗和咨询也能提供不可估量的帮助。
        </p>
        <p>3. 接受和面对现实：在创伤后，接受和面对痛苦经历的现实是第一步。否认或逃避问题通常只会延长痛苦。
        </p>
        <p>4. 积极的心态和期望：预期和期望会极大地影响个体的康复过程。认识到自己有可能从这一创伤中获得某种形式的成长，可能会成为一个积极的心理催化剂。
        </p>
        <p>5. 深入自我反思：对过去、现在和未来的反思有助于你从中找到新的意义和目标。这种意义的重塑可能是促成创伤后成长的关键。
        </p>
        <p>6. 采取行动：有时候，最好的治疗就是采取行动。这可能是寻求专业帮助、 与他人分享你的故事，或者是找到一个有意义的方式来纪念或纾解你所经历的创伤。
        </p>
        <p>7. 终身学习和适应：创伤后成长是一个持续的过程，需要不断地学习和适 应。这可能包括不断地调整你的心态、行为和社交策略，以适应不断变化的个人和社会环境。</p>
        <p>理解创伤后成长并不意味着轻视或忽略创伤所带来的痛苦和复杂性。相反，它 提供了一种新的视角和工具，帮助我们超越“受害者” 的标签，以更为全面、积极和
          有力的方式面对和逾越创伤。这是一个复杂但极具价值的过程，值得每一个愿意面
          对和超越自我的人去尝试和实践。将自己视为一个“受害者”可能会让我们陷入一个 无法逃脱的圈套。然而，创伤后成长的概念鼓励我们超越这个标签，看到自己的内在力量和可能性。它不仅为我们描绘了从创伤到恢复的路径，更为我们展示了一个
          转化痛苦为力量、找回生活意义和目标的途径。因此，每一次的困境都可以视为一次学习和成长的机会，只要我们愿意从中寻找和创造意义。
        </p>
        <b>总结</b>
        <p>总的来说，创伤后应激障碍和急性应激障碍是两种由应激事件引发的复杂心理
          障碍。尽管治疗方法多种多样，但关键是及时识别和干预，以避免长期的负面影响。此外，社会和家庭的支持在恢复过程中也起到了至关重要的作用。我们应该更多地了解这些障碍，以便为需要的人提供更好的帮助和支持。
        </p>
        <b>参考文献</b>
        <p>APA (2020) Summary of Recommendations of the APA GuidelineDevelopment Panel for the Treatment of PTSD.</p>
        <p>APA (2020) Treatment Dose, Timing, and Duration as Described inReviewed Studies.</p>
        <p>American Psychiatric Association (2013) Diagnostic and Statistical Manualof Mental Disorders (5th ed.).
          Arlington, VA: American Psychiatric Publishing.</p>
        <p>Wu, X., Kaminga,A. C., Dai,W., Deng,J., Wang, Z., Pan, X., & Liu,A. (2019).The prevalence of moderate-to-high
          posttraumatic growth: A systematic review and meta-analysis. Journal of Affective Disorders, 243, 408-415.
          doi:10.1016/j.jad.2018.09.023.</p>
      </div>
      <div class="mentalBox" v-if="titles == '心中的拉锯战:理解认知解离的根源'">
        <b>什么是认知解离？</b>
        <p style="text-indent:32px;">在繁华的都市背后，每个人的心灵深处都可能藏有一个小小的秘密—— 那些内心 与行为之间的不协调瞬间。你是否曾经觉得自己做出了与内心信仰相违背的事情？
          或者，你是否曾试图避免某种情感，只因它与你的行为不一致？这种现象在心理学
          上被称为“认知解离” 。它好比是我们心中的一个拉锯战，不断摇摆在我们的思想、 感觉和行为之间。在这篇文章中，我们将探讨这个现象背后的心理机制，以及它如
          何影响我们日常的决策和行为。让我们一起深入理解这个现象，解锁我们心灵深处的秘密。
        </p>
        <p>认知解离（Cognitive Dissonance）是一种认知和心理防御机制，它允许人们 在心理上“切断”或“隔离”某些思想、感受、经验或记忆，使其与主体意识保持分离。
          这通常是为了应对创伤、极度的压力或不安。当解离发生时，这些被隔离的经验可能完全不再被意识到，或者感觉就像它们不是个体自己的一部分。
        </p>
        <p>认知解离作为一个心理学概念的起源可以追溯到19世纪和20世纪初的神经症研究：
        </p>
        <p>1. 法国心理学家Pierre Janet ：在 19世纪末和20世纪初， Janet 对许多病患的 观察得出，当人们遭受创伤性事件时，他们可能会经历一种“切断” 的状态，使他
          们与某些记忆或经验隔离。他认为解离是个体应对过于强烈的刺激或情感的一种方式。 Janet 是最早描述和理论化解离现象的人之一。
        </p>
        <p>2.
          弗洛伊德的心理分析：尽管弗洛伊德最初受到Janet的影响并研究解离，但他后来将重点转向了压抑作为解释患者遗忘创伤经历的主要机制。尽管如此，解离和压抑在某些情况下仍然可以看作是相似的防御机制，它们都允许个体避免与痛苦的、不受欢迎的或冲突的信息打交道。
        </p>
        <p>3. 二战后的研究：二战期间和之后，由于战争造成的心理创伤，对创伤后应 激障碍（ Post-Traumatic Stress Disorder， PTSD）的研究增多。许多受创伤的
          军人和平民经历了显著的解离症状。这进一步促进了对解离现象的关注和研究。
        </p>
        <p>4. 解离性身份障碍：过去称为多重人格障碍，这是一种罕见的疾病，其中个 体有两个或多个独立的身份或人格状态。对这种障碍的关注和研究也加深了对解离现象的了解。
        </p>
        <p>5. 现代研究：随着对创伤和PTSD的研究的增加，对解离的研究也随之增多。 许多现代研究致力于理解解离是如何发生的、它与大脑中的哪些过程有关，以及如何有效地治疗解离症状。

        </p>
        <b>生活中你感受过哪几个解离瞬间？
        </b>
        <p>1. 驾驶自动化：有时，你可能会开车到某个地方，到达后却完全不记得开车过程，感觉像是“ 自动驾驶” 。这就是一个很常见的解离体验。
        </p>
        <p>2. 看电视或阅读：你可能会看着电视或书，突然发现自己完全没有注意到正 在发生的情节或所读的内容，虽然眼睛还在屏幕或书页上，但心思已经完全飘走了。
        </p>
        <p>3. 日常例行公事：在执行常规的、机械性的任务（如刷牙或系鞋带）时，你可能会突然意识到自己并没有真正“在场” ，而是在考虑其他事情。
        </p>
        <p>4. 对话中的心不在焉：与人交谈时，你可能会突然发现自己并没有真正听对方说话，尽管你正在看着对方。
        </p>
        <p>5. 空想：在日常生活中，人们可能会陷入 “ 空想”或“ 白日梦 ” 中，突然发现自己已经完全摆脱了当前的现实场景。
        </p>
        <p>6. 早上的前几分钟：刚醒来时，有时人们可能会暂时感到自己不知道自己在哪里，或者昨天发生了什么，这种情况通常很快就会消失。
        </p>
        <p>7. 过度工作：当人们长时间工作，尤其是在高压情境下，他们可能会感觉与现实世界“ 断开连接” ，仿佛自己在做事，但心不在焉。
        </p>
        <p>8. 公开场合的表现焦虑：在大庭广众之下演讲或表演时，一些人可能会有“ 身体出魂” 的感觉，好像他们的身体与精神是分开的。
        </p>
        <p>9. 重要决策的压力：在必须做出重要决策的时候，一些人可能会觉得他们正在观看自己的生活，而不是真正参与其中。
        </p>
        <p>10. 社交场合的不适：在大型社交聚会中，一些人可能会感到与周围的人和环境分离，好像自己是一个局外人。
        </p>
        <p>11. 突然的负面消息：接收到突如其来的坏消息（例如亲人的去世或意外）时，人们可能会暂时感到与外部世界断开联系。
        </p>
        <p>12. 回忆过去的创伤经验：当人们回忆起痛苦的过去或受伤的经验时，他们可能会暂时与当下的现实断开，重新回到过去。
        </p>
        <p>这些都是轻微的解离状况，大多数人在生活中都可能会遇到。在大部分情况 下，这种解离是短暂的，不会对健康产生负面影响。需要注意的是，如果解离症状持续或影响到日常生活，建议寻求专业帮助。

        </p>
        <b>认知解离的常见原因你是否正在经历？
        </b>
        <p>1. 过度的压力或疲劳：
        </p>
        <p>描述：长时间的工作、缺乏充足的休息或休闲时间，以及持续的身体或心理压力可能导致大脑"关机"以保护自己。
        </p>
        <p>例子：一名会计师在税务申报季节连续工作数周，每天工作超过14小时，可能会在某一时刻感到自己与现实世界脱节，似乎是在自动驾驶状态中完成工作。
        </p>
        <p>2. 强烈的情感反应：
        </p>
        <p>描述：当个体遭遇强烈的情感波动，如悲伤、愤怒或惊讶，他们可能会经历短暂的解离状态。
        </p>
        <p>例子：一名员工突然被告知因为裁员而被解雇，她可能会立刻感到自己与周围环境脱节，好像这一切都不是真的。
        </p>
        <p>3. 高度焦虑或恐惧：
        </p>
        <p>描述：面临特定的恐惧源或压力时，个体可能会体验到解离症状。
        </p>
        <p>例子：有些人在乘坐电梯时，由于幽闭恐惧症，可能会感到四周模糊，似乎自己并不在电梯内。
        </p>
        <p>4. 创伤后反应：
        </p>
        <p>描述：那些经历过身体或心理创伤的人，在回忆或被提醒到那些经历时可能会有解离反应。
        </p>
        <p>例子：一个曾经遭受家暴的人，在看到与创伤相关的电影或听到相关的声音时，可能会感觉到自己被"传送"回那些痛苦的时刻。
        </p>
        <p>5. 生理因素：
        </p>
        <p>描述：某些身体健康状况或药物可能导致解离症状。
        </p>
        <p>例子：长时间失眠的人，可能会在日常活动中感到自己与现实世界断裂。
        </p>
        <p>6. 认知焦点的转移：
        </p>
        <p>描述：当人们的注意力完全被某一情境或事物吸引时，他们可能暂时与其他事物脱节。
        </p>
        <p>例子：一个人可能在看一部引人入胜的电影时，完全沉浸其中，以至于忽略了外界的声音和干扰。

        </p>
        <b>认知解离的好处和坏处
        </b>
        <p>好处：
        </p>
        <p>1. 心理保护：对于有些人来说，尤其是经历过创伤的人，认知解离可能作为一种心理防御机制，帮助他们暂时与痛苦的经验或情境隔离开来。
        </p>
        <p>2. 应对压力：在高度压力的情境下，解离可能帮助个体保持冷静和理性。例 如，应急人员在灾难现场可能会经历短暂的解离，这使他们能够更加有效地执行任务。
        </p>
        <p>3. 促进创意和冥想：某种程度的解离可能帮助人们放松、沉思，进入 "流"状态，进而更有创意地思考问题。
        </p>
        <p>坏处：
        </p>
        <p>1. 现实感丧失：长时间或频繁地经历解离可能导致个体感觉与现实世界断裂，难以分辨现实与幻觉。
        </p>
        <p>2. 记忆问题：强烈的解离症状可能会导致记忆缺失或扭曲，如对某个事件的片段记忆，但对整体情境模糊。
        </p>
        <p>3. 影响日常功能：持续的解离症状可能导致个体在日常生活中功能受损，如驾驶或在工作中出现危险的失误。
        </p>
        <p>4. 情感疏离：认知解离可能导致情感上的疏远，使个体难以与他人建立和维持关系。
        </p>
        <p>5. 增加精神健康风险：频繁的认知解离可能与某些精神健康问题有关，如解离性障碍、焦虑、抑郁或创伤后应激障碍。
        </p>
        <p>总的来说，认知解离在某些情境下可能是有益的，作为一种应对机制。但如果 它持续或频繁出现，可能会对个体的生活和健康带来不良影响。如果有人发现自己经常性地体验这种现象，最好寻求心理健康专家的帮助。
        </p>
        <b>结语</b>
        <p>在现代快节奏的生活中，我们都可能会在某些时候体验到认知解离的现象，就 好像内心上演了一场"拉锯战" 。这些短暂的、零星的感受可能只是我们身体和大脑 的应对机制，帮助我们应对外部压力或创伤。然而，当这些体验变得频繁或持续
          时，它可能成为更深层次的心理问题的征兆。认知解离不仅是心理学上的一个有趣 的概念，也是我们每个人需要关心和了解的现象。通过深入了解其根源，我们不仅 可以更好地理解自己和他人的行为，还可以及时寻找适当的支持和治疗，确保我们
          的心理健康。当你发现自己在生活中遭遇"心中的拉锯战 "时，记住，求助和理解是走向更加幸福人生体验的第一步。
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .enter {
    width: 950px;
    margin: auto;
    display: table;
  }

  .enter .p {
    font-size: 14px;
    padding: 30px 0;
  }

  .enter .p span {
    cursor: pointer;
  }

  .enter .p a {
    font-size: 14px;
  }

  .mentBody {
    padding: 26px 0;
  }

  .mentBody h3 {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #555;
  }

  .mentBody h3 b {
    font-size: 16px;
    display: block;
    font-weight: 100;
    padding: 10px 0;
  }

  .mentalBox {
    margin-bottom: 50px;
  }

  .mentalBox p {
    line-height: 22px;
    color: #333;
    font-size: 14px;
  }

  .mentalBox b {
    color: #333;
    font-size: 15px;
    display: block;
    padding: 18px 0 5px 0;
  }
</style>
<script>
  export default {
    props: ['titles'],
    data() {
      return {}
    },
    created() {
      const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (currentPosition > 0) {
        // 如果当前位置不为零，则执行滚动操作
        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }
    },
    methods: {
      detailHref() {
        this.$emit('updateParentValue', '3');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/mentalDetail.vue